<template>
  <div id="business">

    <div id="hero">
        <!--
        <Slick ref="slick-reviews" :options="slickOptions">
        <div v-for="(slide,index) in slides" v-bind:key="index" class="hero__slide" v-lazy:background-image="slide.wallpaper">
        -->
            <div class="hero__slide" v-lazy:background-image="'../../../../assets/images/business-image.jpg'">
            <div class="hero__slide-content">
                <div class="hero__slide-wrapper">
                    <p class="hero__slide-text">Immagina di connettere i tuoi clienti e le tue risorse umane ad entusiasmanti soluzioni di travel booking</p>
                </div>
            </div>
            </div>
        <!--
        </div>
        </Slick>
        -->
    </div>

    <div id="page">
        <b-container>
            <section>
                <h1 class="text-center">Travel booking integrato, brandizzato, capace comunicare i tuoi valori e i tuoi messaggi.</h1>
                <br><br>
                <Quote :text="'<strong>Scegli il travel</strong> per la tua comunicazione, il tuo marketing, il tuo loyalty, i tuoi incentive'" />
            </section>
        </b-container>

        <b-container fluid>
            <section class="b-cards">

                <div class="b-card"><!--<div class="b-card pointer" @click="window.location.href='#'">-->
                    <div class="b-card--thumb" style="background-image:url('../../../../assets/images/card-1.png')"></div>
                    <div class="b-card--text">
                        <h5 class="b-card--title">Promo e concorsi</h5>
                        <p class="b-card--link">Real time experience</p>
                    </div>
                </div>

                <div class="b-card"><!--<div class="b-card pointer" @click="window.location.href='#'">-->
                    <div class="b-card--thumb" style="background-image:url('../../../../assets/images/card-2.png')"></div>
                    <div class="b-card--text">
                        <h5 class="b-card--title">Incentive al trade</h5>
                        <p class="b-card--link">Viaggi incentive 4.0</p>
                    </div>
                </div>

                <div class="b-card"><!--<div class="b-card pointer" @click="window.location.href='#'">-->
                    <div class="b-card--thumb" style="background-image:url('../../../../assets/images/card-3.png')"></div>
                    <div class="b-card--text">
                        <h5 class="b-card--title">Piani loyalty</h5>
                        <p class="b-card--link">Travel a punti</p>
                    </div>
                </div>

                <div class="b-card"><!--<div class="b-card pointer" @click="window.location.href='#'">-->
                    <div class="b-card--thumb" style="background-image:url('../../../../assets/images/card-4.png')"></div>
                    <div class="b-card--text">
                        <h5 class="b-card--title">Regali aziendali</h5>
                        <p class="b-card--link">Personalizzati in scala</p>
                    </div>
                </div>

                <div class="b-card"><!--<div class="b-card pointer" @click="window.location.href='#'">-->
                    <div class="b-card--thumb" style="background-image:url('../../../../assets/images/card-5.png')"></div>
                    <div class="b-card--text">
                        <h5 class="b-card--title">Welfare aziendale</h5>
                        <p class="b-card--link">Semplice, integrato, desiderato</p>
                    </div>
                </div>

            </section>
        </b-container>

        <b-container>
            <section>
                <h1 class="text-center">Prodotti Vivamod</h1>
                <b-row>
                    <b-col sm="12" lg="6">
                        <p>
                            Soluzioni di online <b>travel booking integrate</b> con le tue piattaforme IT.
                        </p>
                        <p>
                            <b>Credito travel digitale</b>, gift card digitali, cofanetti regalo digitali. 
                        </p>
                        <p>
                            Gift card e <b>cofanetti regalo tradizionali</b> brandizzabili.
                        </p>
                        <p>
                            Ogni prodotto contiene la nostra tecnologia di travel booking flessibile e sicura. 
                            Ogni nostro prodotto si avvale di un solido <b>sistema di customer care al servizio dei tuoi clienti</b> e dei tuoi collaboratori.
                        </p>
                    </b-col>
                    <b-col sm="12" lg="6">
                        <img src="assets/images/phona-prod.png" />
                    </b-col>
                </b-row>
            </section>
        </b-container>

        <b-container>
            <section class="b-icons">
                <h1 class="text-center">Il valore del nostro travel per la tua azienda</h1>
                <b-row>
                    <b-col sm="12">
                        <div class="intro">
                        <p>
                            Da sempre i viaggi sono elementi chiave dei sistemi di <b>rewarding</b> aziendale. 
                        </p>
                        <p>
                            Mai, prima di Vivamod, i viaggi erano stati <b>integrati in modo così semplice</b> e entusiasmante dentro al tuo business.
                        </p>
                        </div>
                    </b-col>
                </b-row>
                <br><br>
                <b-row>
                    <b-col sm="12" md="4">
                        <div class="b-icon">
                            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.39412 41.9726C2.44245 41.8033 1.58078 41.3043 0.960173 40.5632C0.33957 39.8221 -0.000353619 38.8862 2.76052e-07 37.9196V33.3941C-0.000353619 32.4275 0.33957 31.4916 0.960173 30.7505C1.58078 30.0094 2.44245 29.5104 3.39412 29.3411L8.74016 28.4086C9.37115 26.0803 10.3032 23.8443 11.5126 21.7571L8.37961 17.3063C7.82423 16.5138 7.56591 15.5509 7.65004 14.5868C7.73417 13.6227 8.15536 12.7191 8.83962 12.0348L12.0472 8.82719C12.7295 8.1439 13.631 7.72316 14.5929 7.63901C15.5549 7.55487 16.5157 7.81272 17.3063 8.36718L21.7571 11.5126C23.8447 10.307 26.0808 9.37912 28.4086 8.75259L29.3411 3.40655C29.5078 2.4526 30.0057 1.58802 30.747 0.964935C31.4884 0.341845 32.4257 0.000161532 33.3941 0H37.932C38.8965 0.00256134 39.8295 0.343808 40.568 0.964159C41.3065 1.58451 41.8036 2.44455 41.9726 3.39411L42.9051 8.74016C45.2379 9.36959 47.4782 10.3017 49.569 11.5126L54.0075 8.39204C54.798 7.83758 55.7588 7.57974 56.7208 7.66388C57.6827 7.74802 58.5842 8.16876 59.2665 8.85205L62.4865 12.0472C63.1708 12.7316 63.592 13.6352 63.6761 14.5992C63.7602 15.5633 63.5019 16.5262 62.9465 17.3187L59.8259 21.7571C60.735 23.3696 61.4805 25.0689 62.0514 26.8297C60.7258 28.4716 59.8363 30.4216 59.4654 32.499L59.0303 34.9855L57.7 35.5325L55.6486 34.1028C53.5338 32.6161 51.0103 31.8213 48.4252 31.8276C48.0149 31.8276 47.6295 31.9022 47.1819 31.9395C46.5522 29.9412 45.4184 28.1388 43.8897 26.7061C42.361 25.2733 40.489 24.2586 38.4541 23.7596C36.4192 23.2606 34.2901 23.2942 32.272 23.8572C30.2539 24.4202 28.4149 25.4936 26.9322 26.9739C25.4495 28.4542 24.3731 30.2915 23.8068 32.3086C23.2406 34.3258 23.2035 36.4549 23.6992 38.4906C24.1949 40.5262 25.2066 42.3999 26.6368 43.9309C28.0671 45.462 29.8676 46.5987 31.8649 47.2317C31.5715 50.2156 32.3566 53.206 34.0779 55.661L35.5201 57.7124C35.3336 58.1475 35.1471 58.5951 34.9731 59.0427L32.4865 59.4778C30.4092 59.8488 28.4591 60.7383 26.8172 62.0638C25.0565 61.4927 23.3573 60.7472 21.7447 59.8384L17.2938 62.959C16.5029 63.5085 15.5439 63.7624 14.5847 63.676C13.6255 63.5896 12.7272 63.1685 12.0472 62.4865L8.83962 59.2789C8.15536 58.5946 7.73417 57.691 7.65004 56.7269C7.56591 55.7628 7.82423 54.8 8.37961 54.0075L11.5126 49.569C10.3069 47.4815 9.37898 45.2454 8.75259 42.9175L3.39412 41.9726ZM120 71.811V77.5673C119.998 78.7935 119.565 79.98 118.776 80.9188C117.987 81.8576 116.893 82.4889 115.686 82.702L108.91 83.9453C108.109 86.8785 106.931 89.6952 105.404 92.3249L109.358 97.9693C110.089 98.9834 110.432 100.226 110.325 101.472C110.218 102.718 109.667 103.883 108.773 104.758L104.758 108.773C103.889 109.642 102.743 110.176 101.52 110.283C100.296 110.39 99.0745 110.062 98.0688 109.358L92.3249 105.404C89.6714 106.936 86.8294 108.114 83.8707 108.91L82.6274 115.686C82.4143 116.893 81.783 117.987 80.8442 118.776C79.9054 119.565 78.7189 119.998 77.4927 120H71.8483C70.6221 119.998 69.4357 119.565 68.4968 118.776C67.558 117.987 66.9268 116.893 66.7136 115.686L65.4704 108.91C62.5158 108.114 59.6778 106.935 57.0286 105.404L51.4339 109.358C50.4282 110.062 49.2064 110.39 47.9831 110.283C46.7599 110.176 45.6134 109.642 44.7451 108.773L40.6796 104.758C39.8005 103.885 39.2602 102.728 39.1555 101.493C39.0507 100.259 39.3882 99.0275 40.1077 98.0191L44.0613 92.3249C42.5303 89.6755 41.3517 86.8376 40.5553 83.8831L33.7795 82.6399C32.572 82.4267 31.478 81.7955 30.6892 80.8567C29.9004 79.9178 29.4672 78.7314 29.4654 77.5052V71.8483C29.4666 70.6239 29.8981 69.4389 30.6844 68.5003C31.4707 67.5618 32.5618 66.9294 33.7671 66.7136L40.5429 65.4704C41.3383 62.5116 42.517 59.6695 44.0489 57.0162L40.1077 51.4339C39.4031 50.4282 39.0755 49.2064 39.1823 47.9831C39.2892 46.7599 39.8238 45.6134 40.6921 44.7451L44.7576 40.6796C45.6266 39.8164 46.7714 39.2861 47.9919 39.1816C49.2123 39.077 50.4307 39.4049 51.4339 40.1077L57.0783 44.0613C59.7275 42.5299 62.5655 41.3513 65.5201 40.5553L66.7634 33.7795C66.9765 32.572 67.6078 31.478 68.5466 30.6892C69.4854 29.9004 70.6719 29.4672 71.898 29.4654H77.6544C78.8723 29.4753 80.0485 29.9108 80.9794 30.6963C81.9102 31.4819 82.5372 32.5681 82.7518 33.7671L83.995 40.5429C86.9116 41.3521 89.7114 42.5347 92.3249 44.0613L98.0191 40.1077C99.0247 39.4031 100.247 39.0755 101.47 39.1823C102.693 39.2892 103.84 39.8238 104.708 40.6921L108.773 44.7576C109.642 45.6258 110.176 46.7723 110.283 47.9956C110.39 49.2189 110.062 50.4407 109.358 51.4463L105.404 57.0908C106.936 59.7439 108.115 62.5861 108.91 65.545L115.686 66.7882C116.881 66.999 117.965 67.6194 118.752 68.5428C119.54 69.4662 119.981 70.635 120 71.8483V71.811ZM90.2611 74.7327C90.2611 71.6615 89.3504 68.6592 87.6441 66.1056C85.9378 63.552 83.5126 61.5616 80.6752 60.3863C77.8377 59.211 74.7155 58.9035 71.7033 59.5027C68.691 60.1018 65.9242 61.5808 63.7525 63.7525C61.5808 65.9242 60.1018 68.691 59.5027 71.7033C58.9035 74.7155 59.211 77.8377 60.3863 80.6752C61.5616 83.5126 63.552 85.9378 66.1056 87.6441C68.6592 89.3504 71.6615 90.2611 74.7327 90.2611C78.8511 90.2611 82.8008 88.6251 85.7129 85.7129C88.6251 82.8008 90.2611 78.8511 90.2611 74.7327Z" fill="url(#wheels-gradient)"/>
                                <defs>
                                <linearGradient id="wheels-gradient" x1="0" y1="60" x2="120" y2="60" gradientUnits="userSpaceOnUse">
                                <stop offset="0.00128142" stop-color="#FF974F"/>
                                <stop offset="1" stop-color="#FF5652"/>
                                </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <div class="text">Travel tech flessibile e robusta al tuo servizio</div>
                    </b-col>
                    <b-col sm="12" md="4">
                        <div class="b-icon">
                            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M85.3574 14.6426C65.8338 -4.88088 34.1662 -4.88088 14.6426 14.6426C-4.88088 34.1662 -4.88088 65.8338 14.6426 85.3574C34.1662 104.881 65.8338 104.881 85.3574 85.3574C104.881 65.8338 104.881 34.1778 85.3574 14.6426ZM67.6467 29.7037C71.6212 29.7037 74.8402 32.9227 74.8402 36.8972C74.8402 40.8716 71.6212 44.0906 67.6467 44.0906C63.6723 44.0906 60.4532 40.8716 60.4532 36.8972C60.4532 32.9227 63.6723 29.7037 67.6467 29.7037ZM32.3417 29.2504C36.3161 29.2504 39.5352 32.4695 39.5352 36.4439C39.5352 40.4184 36.3161 43.6374 32.3417 43.6374C28.3672 43.6374 25.1482 40.4184 25.1482 36.4439C25.1365 32.4695 28.3672 29.2504 32.3417 29.2504ZM75.4445 63.4863C73.1319 67.914 69.6107 71.6793 65.4271 74.387C59.0006 78.5357 50.9587 79.8024 43.5212 78.1406C35.4678 76.3277 28.3556 70.796 24.5439 63.4863C23.6374 61.7548 24.1487 59.7792 25.799 58.7101C27.3329 57.7223 29.7269 58.3382 30.5752 59.9651C30.9471 60.6856 31.3539 61.3829 31.7838 62.0569C32.0046 62.4056 32.2371 62.731 32.4695 63.068C32.5741 63.2191 32.7252 63.3701 32.8181 63.5328C33.7594 64.6949 34.7937 65.7641 35.921 66.7403C36.1766 66.9611 36.4323 67.1702 36.688 67.3794C36.6299 67.3446 36.5718 67.2981 36.5253 67.2516C36.4904 67.2284 36.4788 67.2167 36.4672 67.2167C36.4904 67.24 36.839 67.5073 36.8739 67.5305C36.8623 67.5189 36.8158 67.4724 36.6996 67.391C36.7693 67.4492 36.8507 67.5073 36.932 67.5537C37.4433 67.9256 37.9779 68.2859 38.5125 68.6229C39.4771 69.2156 40.4765 69.7385 41.5107 70.2034C43.312 70.9239 45.1714 71.4352 47.0889 71.7257C49.0296 71.9465 50.982 71.9465 52.9227 71.7257C54.8286 71.4236 56.6996 70.9239 58.5009 70.2034C59.5352 69.7501 60.5346 69.2156 61.4991 68.6229C62.0686 68.2743 62.6148 67.9024 63.1493 67.5073C63.1842 67.484 63.2191 67.4608 63.2539 67.4375C63.2074 67.4724 63.161 67.5073 63.1145 67.5537C63.1842 67.5073 63.2423 67.4492 63.312 67.4027C63.3004 67.4143 63.2772 67.4259 63.2655 67.4375C63.3004 67.4027 63.3469 67.3678 63.3818 67.3446C63.6258 67.147 63.8582 66.9494 64.0906 66.7519C65.2295 65.7641 66.2754 64.6833 67.2167 63.5096C67.2748 63.4399 67.3329 63.3585 67.3911 63.2888C67.4143 63.2539 67.4492 63.2191 67.4724 63.1842C67.4492 63.2191 67.4259 63.2423 67.4027 63.2772C67.4492 63.2074 67.4956 63.1261 67.5421 63.068C67.7746 62.7426 68.007 62.4056 68.2278 62.0569C68.6694 61.3829 69.0645 60.6856 69.4364 59.9651C70.3428 58.2336 72.609 57.8617 74.2127 58.7101C75.9094 59.6281 76.2812 61.871 75.4445 63.4863Z" fill="url(#smile-grad)"/>
                                <defs>
                                <linearGradient id="smile-grad" x1="0" y1="50" x2="100" y2="50" gradientUnits="userSpaceOnUse">
                                <stop offset="0.00128142" stop-color="#FF974F"/>
                                <stop offset="1" stop-color="#FF5652"/>
                                </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <div class="text">User Experience all’altezza delle attese dell’utente contemporaneo</div>
                    </b-col>
                    <b-col sm="12" md="4">
                        <div class="b-icon">
                            <svg width="120" height="105" viewBox="0 0 120 105" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M82.4942 61.3528C79.5405 64.253 76.0375 66.5344 72.1907 68.0633C68.3438 69.5921 64.2305 70.3377 60.0918 70.2562C57.788 70.2562 55.4721 70.2562 53.1683 70.2562C52.7867 70.2314 52.4046 70.2943 52.051 70.4398C51.6975 70.5854 51.3819 70.8099 51.1284 71.0961C45.9328 76.5678 40.6891 82.0034 35.5295 87.451C35.0474 88.0198 34.4485 88.4781 33.7736 88.7949C33.0986 89.1116 32.3634 89.2794 31.6178 89.2869C30.994 89.2855 30.3768 89.1594 29.8025 88.916C29.2282 88.6727 28.7083 88.317 28.2734 87.8698C27.8385 87.4226 27.4974 86.893 27.2702 86.3121C27.0429 85.7312 26.9341 85.1108 26.9501 84.4872C26.9501 79.9515 26.9501 75.4198 26.9501 70.8922C26.9501 70.0282 26.7101 69.6922 25.8342 69.5243C13.0431 66.2365 5.24363 57.8971 1.4519 45.5259C0.845245 43.1889 0.360624 40.8218 0 38.4344L0 31.8589C0.231319 29.7659 0.632616 27.6952 1.19992 25.6673C4.3317 14.2921 11.0752 6.0487 22.3064 1.765C25.5349 0.568177 28.9547 -0.0295697 32.3977 0.00112482C41.4331 0.00112482 50.4805 0.00112482 59.5278 0.00112482C72.1509 -0.058871 81.5943 5.55674 88.0738 16.08C92.3348 23.165 94.1004 31.4728 93.0892 39.6783C92.0779 47.8839 88.3479 55.5144 82.4942 61.3528Z" fill="url(#baloon-grad)"/>
                                <path d="M111.04 43.69C107.707 40.6917 103.592 38.6989 99.1732 37.9424C99.1732 38.2664 99.0892 38.4583 99.0652 38.6383C98.6653 44.4296 97.0286 50.0679 94.2655 55.1732C86.8501 68.6122 75.6069 75.9557 60.0199 76.1477C58.3761 76.1477 56.7322 76.1477 55.0883 76.1477C53.7444 76.1477 53.1444 77.1796 53.8284 78.2956C57.6201 84.4871 62.9237 88.7228 70.1832 89.9827C73.3235 90.3677 76.4876 90.5242 79.6506 90.4507C80.0144 90.4283 80.3785 90.489 80.7153 90.6283C81.0521 90.7676 81.3527 90.9818 81.5944 91.2547C83.7063 93.5105 85.8661 95.7183 88.002 97.9502C89.6459 99.6661 91.2778 101.418 92.9696 103.11C93.6852 103.931 94.6969 104.435 95.7831 104.511C96.8694 104.588 97.9417 104.23 98.7652 103.518C99.2618 103.066 99.6486 102.507 99.8961 101.883C100.144 101.259 100.245 100.587 100.193 99.918C100.193 97.0742 100.193 94.2184 100.193 91.3746C100.193 90.3547 100.469 89.9947 101.477 89.6108C103.965 88.817 106.35 87.7294 108.581 86.371C122.716 76.6517 123.951 55.1612 111.04 43.69Z" fill="url(#paint1_linear)"/>
                                <defs>
                                <linearGradient id="baloon-grad" x1="0" y1="44.6434" x2="93.3671" y2="44.6434" gradientUnits="userSpaceOnUse">
                                <stop offset="0.00128142" stop-color="#FF974F"/>
                                <stop offset="1" stop-color="#FF5652"/>
                                </linearGradient>
                                <linearGradient id="paint1_linear" x1="53.5439" y1="71.2318" x2="120" y2="71.2318" gradientUnits="userSpaceOnUse">
                                <stop offset="0.00128142" stop-color="#FF974F"/>
                                <stop offset="1" stop-color="#FF5652"/>
                                </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <div class="text">Un’assistenza al viaggiatore attenta, disponibile e multicanale</div>
                    </b-col>
                </b-row>
            </section>
        </b-container>

        <br>

        <b-container>
            <section>
                <h1 class="text-center">Ci sintonizziamo con i tuoi valori</h1>
                <b-row>
                    <b-col sm="12">
                        <div class="intro">
                            <p>
                                Vivamod permette di creare canali di viaggio tematici disegnati su misura per potenziare i messaggi delle tue campagne ed esprimere i tuoi valori aziendali
                            </p>
                            <p>
                                Un universo di viaggi, oltre {{config.guiSettings.totalPropertiesCount}} hotel, B&B, appartamenti in Italia e nel mondo disponibili in tempo reale.
                            </p>
                        </div>
                    </b-col>
                </b-row>
            </section>
        </b-container>

        <br>

        <b-container fluid>
            <section>
                <b-row>
                    <b-col sm="12">
                        <div class="b-slider">
                            <div class="b-slides">
                                <Slick ref="slick" :options="slickOptions">
                                    <div v-for="(i,index) in [1,2,3,4,5,6,7,8,9,10,11,12,13]" v-bind:key="index">
                                    <div class="b-slide">
                                        <div class="content">
                                            <img class="phone" src="assets/images/slider-pagina-business/phone.png" />
                                            <img class="screen" :src="'assets/images/slider-pagina-business/Vivamod_IN_VadoBay_'+i+'.jpg'" />
                                        </div>
                                    </div>
                                    </div>
                                </Slick>
                            </div>

                            <div class="b-left" id="b-left">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dleft)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M45.1672 26.8429C45.9328 26.8429 46.507 27.0343 47.0811 27.6084C48.0381 28.5654 48.0381 30.2879 47.0811 31.4362L38.4687 40.0487L47.0811 48.6611C48.0381 49.6181 48.0381 51.3405 47.0811 52.4889C46.1242 53.4458 44.4017 53.4458 43.2534 52.4889L32.727 41.9625C31.7701 41.0056 31.7701 39.2831 32.727 38.1348L43.2534 27.6084C43.8275 27.0343 44.4017 26.8429 45.1672 26.8429Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dleft" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                            <div class="b-right" id="b-right">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dright)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M34.6413 53.2066C33.8758 53.2066 33.3016 53.0152 32.7275 52.441C31.7705 51.4841 31.7705 49.7616 32.7275 48.6133L41.3399 40.0008L32.7275 31.3884C31.7705 30.4314 31.7705 28.7089 32.7275 27.5606C33.6844 26.6037 35.4069 26.6037 36.5552 27.5606L47.0816 38.0869C48.0385 39.0439 48.0385 40.7664 47.0816 41.9147L36.5552 52.441C35.9811 53.0152 35.4069 53.2066 34.6413 53.2066Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dright" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </section>
        </b-container>

        <br>

        <b-container>
            <section>
                <h1 class="text-center">Il tuo branding, la tua identità</h1>
                <b-row>
                    <b-col sm="12" lg="6">
                        <img src="assets/images/branding.png" />
                    </b-col>
                    <b-col sm="12" lg="6">
                        <p>
                            Le nostre soluzioni sono pensate per potersi allineare perfettamente con la tua brand identity.
                        </p>
                        <p>
                            I tuoi clienti e i tuoi collaboratori potranno vivere un’esperienza di travel booking straordinaria all’interno di un eco-sistema che rispetta la tua brand identity e i tuoi valori di marca.
                        </p>
                    </b-col>
                </b-row>
            </section>
        </b-container>

    </div>

  </div>
</template>

<script>
  //import Vue from 'vue'
  import Slick from 'vue-slick';
  import Quote from '../../blocks/common/quote'

  export default {
    name: 'vivamod-business',
    metaInfo: {
      title: process.env.VUE_APP_SITE_PAYOFF,
    },
    components: {
      Slick,
      Quote,
    },
    data() {
        return {
          //slides: Object.values(Vue.prototype.$config.sliderHome.public),
          slickOptions: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots:false,
                //fade:true,
                //arrows:false,
                //autoplay:true,
                speed: 500,
                //autoplaySpeed: 7500,
                prevArrow: '#b-left',
                nextArrow: '#b-right',
                responsive: [{
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }]
          },
          submitCallback: function()
          {
            //this.mixinGoTo('search',{})
          },
          config: this.appConfig(),
        }
    },
    created()
    {
    },
    mounted() {
    },
    methods:{
    },
    computed: {
    }
  }
</script>

<style lang="scss">
    
    @import '@/scss/_vivamod.scss';

    .page-vivamod-business
    {
        @extend .vivamod !optional;
    }
</style>